module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAQCAMAAADK8RQqAAAAM1BMVEUAAABVVVVWVlZVVVVTU1NWVlZUVFRVVVVQUFBWVlZVVVVVVVVWVlZWVlZTU1NUVFRWVlb/JpBpAAAAEHRSTlMAv9+AIKBwYBDvkDDPr1BA3BjM5wAAAFpJREFUGNNtzkcOwCAMBdGhtxTuf9oQgVBieMtZ2B/MqRYBfN0JuG033LucLJhN9zRqyZlX1CJruiKypRNbLyb3m9iJF4ovm+TxIYxeEPI8LhwtO1ZWVxVheABQNwx1vGGfPgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wheel/triangle.png
// module id = Vo1Z
// module chunks = 0